import {Block, Col, Row} from 'jsxstyle'
import React, {useState} from 'react'
import {motion} from 'framer-motion'

import i18n from '../../common/i18n'
import Loader from '../../components/Loader'
import {UserRole} from '../../services/User/type'
import CustomToogle from '../../components/CustomToggle'
import DynamicFormField from '../../components/FormField'
import {useXpertKnowledgeAuthContext} from '../../components/AuthContext/XpertKnowledgeAuthContext'
import {ReactComponent as XpertKnowledgeLogo} from '../../common/assets/xpert-knowledge-logo.svg'

const Login: React.FC = () => {
  const {loginUsernamePassword, isLoading, isLoginFailed, setIsLoginFailed} = useXpertKnowledgeAuthContext()
  const [username, setUsername] = useState<string>('')
  const [password, setPassword] = useState<string>('')

  const [isAdminLoginChecked, setIsAdminLoginChecked] = useState<boolean>(false)
  const [shouldShake, setShouldShake] = useState<boolean>(false)

  const handleLogin = async () => {
    try {
      if (!username || !password) {
        throw new Error('Missing username or password')
      }
      await loginUsernamePassword({username: username, password: password, role: isAdminLoginChecked ? UserRole.ADMIN : UserRole.AGENT})
    } catch (error) {
      console.error('Error during username / password authentication:', error)
      setIsLoginFailed(true)
      setShouldShake(true)
      setTimeout(() => setShouldShake(false), 300)
      setUsername('')
      setPassword('')
    }
  }

  return (
    <>
      <Block textAlign="center" marginTop="80px">
        <XpertKnowledgeLogo height={22} color="black" />
      </Block>

      <Block
        width="360px"
        padding="40px"
        background="#fff"
        borderRadius="16px"
        boxShadow="0 0 0 1px rgba(0,0,0,0.05), 0 4px 20px rgba(0,0,0,0.1)"
        margin="20px auto"
      >
        <Block fontSize="20px" fontWeight={600} textAlign="center" marginBottom="28px">
          {i18n.t('xk.login.title')}
        </Block>

        {isLoginFailed && (
          <>
            <motion.div
              initial="hidden"
              animate={shouldShake ? 'animate' : 'hidden'}
              variants={{
                hidden: {x: 0},
                animate: {
                  x: [0, -5, 5, -5, 0],
                  transition: {duration: 0.25},
                },
              }}
              style={{
                animationIterationCount: 1,
                backgroundColor: '#FFC4C4',
                color: '#AB0D0D',
                padding: '15px',
                borderRadius: '8px',
                textAlign: 'center',
                marginBottom: '28px',
              }}
            >
              {i18n.t('xk.login.errorMessage')}
            </motion.div>
          </>
        )}

        <Block marginBottom="16px">
          <Block fontSize="12px" fontWeight={500} marginBottom="4px">
            {i18n.t('xk.login.usernameLabel')}
          </Block>
          <DynamicFormField
            type="username"
            placeholder={i18n.t('xk.login.usernamePlaceholder')}
            value={username}
            onEdit={(value) => setUsername(value)}
          />
        </Block>

        <Block marginBottom="12px">
          <Block fontSize="12px" fontWeight={500} marginBottom="4px">
            {i18n.t('xk.login.passwordLabel')}
          </Block>
          <DynamicFormField
            type="password"
            placeholder={i18n.t('xk.login.passwordPlaceholder')}
            value={password}
            onEdit={(value) => setPassword(value)}
          />
        </Block>

        <Row marginBottom="28px" alignItems="center">
          <CustomToogle isChecked={isAdminLoginChecked} onChange={(newIsChecked) => setIsAdminLoginChecked(newIsChecked)} />
          <Block marginLeft="8px" fontSize="12px" fontWeight={400}>
            {i18n.t('xk.login.adminLogin')}
          </Block>
        </Row>

        {/* <Block
          textAlign="left"
          fontSize="12px"
          color="#7a38cc"
          hoverColor="#5e2a99"
          marginBottom="20px"
          cursor="pointer"
          props={{
            onClick: () => {},
          }}
        >
          {i18n.t('xk.login.forgotPassword')}
        </Block> */}

        <Col>
          <Block
            component="button"
            padding="12px"
            width="100%"
            border="1px solid #7A42C2"
            borderRadius="12px"
            backgroundColor="#7A42C2"
            hoverBackgroundColor="#EDE7F4"
            hoverColor="#7A42C2"
            fontWeight={500}
            color="#F7F8F9"
            fontSize="14px"
            cursor="pointer"
            alignItems="center"
            justifyContent="center"
            props={{
              onClick: handleLogin,
              disabled: isLoading,
            }}
          >
            {isLoading ? <Loader size={10} borderWidth="3px" borderColor="#fff" borderTopColor="#7a38cc" /> : i18n.t('xk.login.loginButton')}
          </Block>

          {/* <Block textAlign="center" fontSize="14px" color="#999" margin="8px">
            <Row alignItems="center" justifyContent="center" margin="8px 0">
              <Block flex="1" height="1px" backgroundColor="#ddd" />
              <Block margin="0 8px" fontSize="14px" color="#999">
                {i18n.t('xk.login.orSeparator')}
              </Block>
              <Block flex="1" height="1px" backgroundColor="#ddd" />
            </Row>
          </Block> */}

          {/* <Block
            component="button"
            padding="12px"
            width="100%"
            borderRadius="12px"
            background="transparent"
            hoverBackgroundColor="#EDE7F4"
            hoverColor="#7A22C2"
            border="1px solid #7A42C2"
            fontWeight={500}
            color="#7a38cc"
            fontSize="14px"
            cursor="pointer"
            alignItems="center"
            justifyContent="center"
            props={{
              onClick: () => {},
            }}
          >
            {i18n.t('xk.login.ssoButton')}
          </Block> */}

          {/* <Row gap="8px" alignItems="center" marginTop="18px">
            <CustomCheckbox
              checked={checked}
              onChange={() => ())}
              borderColor="#7a38cc"
              backgroundColorChecked="#7a38cc"
              backgroundColorUnchecked="#ffffff"
            ></CustomCheckbox>
            <Block fontSize="12px" color="#888888" fontWeight={300}>
              {i18n.t('xk.login.rememberMe')}
            </Block>
          </Row> */}
        </Col>
      </Block>
    </>
  )
}

export default Login
